import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import * as spriteIcons from 'assets/svg/sprite'
import ConfirmModal from 'components/UI/Modal/Confirm/ConfirmModal'
import DeactivateAccountModal from 'components/UI/Modal/DeleteAccount/DeactivateAccountModal'
import DeleteAccountModal from 'components/UI/Modal/DeleteAccount/DeleteAccountModal'
import { useModalContext } from 'context/modalContext'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { logoutUser } from 'services/endpoints/auth'
import { useUserProfile } from 'store'

import { MainSettingsPage } from '../layout'

export const PrivacyAndSecurity = () => {
    const { t } = useTranslation()
    const userData = useUserProfile()
    const modalData = useModalContext()
    const navigate = useNavigate()

    const toggleDeleteModal = () => {
        modalData.addModal(
            t('deleteAccount'),
            <DeleteAccountModal type='delete' />
        )
    }
    const toggleDeactivateModal = () => {
        modalData.addModal(
            t('deactivateAccount'),
            <DeactivateAccountModal type='deactivate' />
        )
    }

    const privacyAndSecurityCardsFirst = [
        {
            icon: <spriteIcons.IconManLineThrough />,
            body: t('blockedUsers'),
            link: '/settings/account/privacy-and-security/blocked-users',
            currentData: `${userData?.blocked_users_count} users`,
            absfix: true
        },
        ...(userData?.role === 'model'
            ? [
                {
                    icon: <spriteIcons.IconManLineThrough />,
                    body: t('restrictedUsers'),
                    link: '/settings/account/privacy-and-security/restricted-users',
                    currentData: `${userData?.restricted_users_count} users`,
                    absfix: true
                },
                  {
                      icon: <spriteIcons.IconGPSPoint />,
                      body: t('geoBlocking'),
                      link: '/settings/account/privacy-and-security/geo-blocking',
                      absfix: true
                  },
                  {
                      icon: <spriteIcons.IconMagnifyingGlassChecked />,
                      body: t('discoverySettings'),
                      link: '/settings/account/privacy-and-security/discovery-settings',
                      absfix: true
                  },
                  {
                      icon: <spriteIcons.IconMagnifyingGlassChecked />,
                      body: t('watermarkSettings'),
                      link: '/settings/account/privacy-and-security/watermark-settings',
                      absfix: true
                  }
              ]
            : []),
        {
            icon: <spriteIcons.IconScanSquare />,
            body: t('twoFactorAuthentication'),
            link: '/settings/account/privacy-and-security/two-step-verification',
            absfix: true
        },
        {
            icon: <spriteIcons.IconNote />,
            body: t('loginSessions'),
            link: '/settings/account/privacy-and-security/login-sessions',
            absfix: true
        }
    ]

    const privacyAndSecurityCardsSecond = [
        ...(userData?.role === 'model'
            ? [
                {
                    icon: <spriteIcons.IconTrashcanLarge />,
                    body: t('deactivateAccount'),
                    clickFn: () => {
                        toggleDeactivateModal()
                    }
                }
            ]
            : []),
        {
            icon: <spriteIcons.IconTrashcanLarge />,
            body: t('deleteAccount'),
            clickFn: () => {
                toggleDeleteModal()
            }
        },
        {
            icon: <spriteIcons.IconLogOut />,
            body: t('logOut'),
            clickFn: () => {
                modalData.addModal(
                    `${t('logOut')}?`,
                    <ConfirmModal
                        confirmFn={() => {
                            logoutUser((userData?.role === 'model' ? 'model' : 'fan'))
                        }}
                    />
                )
            }
        }
    ]

    return (
        <WithHeaderSection
            headerSection={
                <LayoutHeader
                    type='basic'
                    section={t('account')}
                    title={t('privacySecurity')}
                />
            }
        >
            <MainSettingsPage
                settingsTop={privacyAndSecurityCardsFirst}
                settingsBot={privacyAndSecurityCardsSecond}
            />
        </WithHeaderSection>
    )
}
